import { clearBuyPriceMapper } from 'data-source/mappers/oneDealPriceMapper'
import { oneDealMapper } from 'data-source/mappers/oneDealMapper'
import { paginationMapper } from 'data-source/mappers/paginationMapper'

import type { ApiDealsPageProps } from 'data-source/types.wp'
import type { DSDealsPageData } from 'shared-definitions/types'
import type { MetaMapperOpts } from 'data-source/mappers/metaMapper'

export function dealsPageDataMapper(
  input: ApiDealsPageProps,
  opts: MetaMapperOpts
): DSDealsPageData {
  return {
    title: input.title,
    subtitle: input.subtitle,
    deals: {
      ...paginationMapper(input.content.content),
      items: input.content.content.posts.map(item => ({
        ...oneDealMapper(item, opts),
        price: clearBuyPriceMapper(item),
      })),
    },
    hot: input.content.hot.map(item => ({
      ...oneDealMapper(item, opts),
      price: clearBuyPriceMapper(item),
    })),
  }
}
